import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NavController, LoadingController, AlertController, MenuController, ModalController } from '@ionic/angular';
import { Router } from '@angular/router';

import { Constants } from "../../models/constants";
import { AppointmentTime } from "../../models/appointment-time";
import { SelectedServiceTypeList } from "../../models/selected-service-type-list";

import { CostBreakdownPage } from '../cost-breakdown/cost-breakdown.page';

import { ApptCreator } from "../../services/appt-creation-service";
import { UserService } from "../../services/user-service";
import { Util } from "../../services/util";
import { Alert } from "../../services/alert";
import { AnalyticsService } from '../../services/analytics-service';
import { InvoiceTasks, PayInvoiceParams } from '../../services/invoice-tasks';
import { PaymentService } from '../../services/payment-service';
import { MetaTagService } from '../../services/meta-tag-service';
import { ObservableService } from 'src/app/services/observable-service';

declare var Stripe: any;

@Component({
  selector: 'app-confirm-invoice',
  templateUrl: './confirm-invoice.page.html',
  styleUrls: ['./confirm-invoice.page.scss'],
})
export class ConfirmInvoicePage implements OnInit {

  cardFields: {
    cardholderName?: string
  } = {}

  fields: {
    promoCode?: string
  } = {}

  stripe: any;
  card: any;

  previousController: string;

  selectedCustomer?: any

  paymentPickerOpen = false
  addingNewPayment = false
  confirming = false
  confirmed = false

  invoiceRequestInfo: any

  // UI Params
  apptAddressString: string = '';

  constructor(
    private navCtrl: NavController,
    private loadingCtrl: LoadingController,
    private alert: Alert,
    public userService: UserService,
    private observables: ObservableService,
    private alertCtrl: AlertController,
    private analytics: AnalyticsService,
    private router: Router,
    private changeRef: ChangeDetectorRef,
    private menuCtrl: MenuController,
    public apptCreator: ApptCreator,
    private paymentService: PaymentService,
    private metaTagService: MetaTagService,
    private modalCtrl: ModalController,
  ) {

    if (Constants.DEV_MODE) {
      this.stripe = Stripe(Constants.DEV_STRIPE_KEY);
    } else {
      this.stripe = Stripe(Constants.STRIPE_KEY);
    }

    if (this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras.state) {
      // We came from nav push. Load in initial props.
      const { state: navState } = this.router.getCurrentNavigation().extras
      if (navState) {
        this.previousController = navState.previousController;
        this.invoiceRequestInfo = navState.invoiceRequestInfo;
        console.log(this.invoiceRequestInfo)
      }
    } else {
      this.alert.show('Payment Canceled', 'Please try again.');
      this.navCtrl.navigateBack('/explore')
      return
    }

  }

  ngOnInit() {
  }

  ngAfterViewInit() {

    this.observables.publishMinimizeAllChats()

    this.selectedCustomer = this.userService.user.customer

    // this.analytics.track(AnalyticsService.ViewedConfirmBooking)
    // this.analytics.track(AnalyticsService.ViewRequestApptConfirm)
  }

  ionViewWillEnter() {
    this.updateUIParams();
    this.menuCtrl.enable(false);
  }

  ionViewDidEnter() {
    this.setupStripe('card-element');
    this.metaTagService.updateTitle(`Confirm Payment`)
  }

  private setupStripe(cardElementID: string){

    if (!document.getElementById(cardElementID)) {
      console.log('no card element')
      return
    }

    let elements = this.stripe.elements();
    var style = {
      base: {
        color: '#25282a',
        lineHeight: '50px',
        fontFamily: '"Fira Sans", Arial, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '14px',
        '::placeholder': {
          color: '#86878e'
        },
        border: '1px solid grey'
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };

    this.card = elements.create('card', { style: style });

    this.card.mount('#' + cardElementID);

    this.card.addEventListener('change', (event: any) => {
      var displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });
  }

  goBack() {
    this.navCtrl.navigateBack(this.previousController);
  }

  updateUIParams() {

    let address = this.apptCreator.address
    if (this.apptCreator.customAddressData) {
      address = this.apptCreator.customAddressData.address
    }

    this.apptAddressString = Util.formatAddress(address);
  }



  // -- Payment options --

  selectedPaymentCardText() {

    if (this.selectedCustomer) {
      return this.paymentCardText(this.userService.user.customer)
    } else {
      return 'No payment selected'
    }
  }

  paymentCardText(customer: any) {

    if (customer.cardBrand) {
      return `${customer.cardBrand} ending *${customer.last4}`;
    } else {
      return `Card ending ${customer.last4}`;
    }
  }

  editPayment() {
    this.paymentPickerOpen = true
    this.changeRef.detectChanges()
  }

  selectCustomer(customer: any) {
    this.closePaymentPicker()
    this.selectedCustomer = customer
    this.changeRef.detectChanges()
  }

  closePaymentPicker() {
    this.paymentPickerOpen = false
    this.changeRef.detectChanges()
  }

  addNewPayment() {
    this.closePaymentPicker()
    this.addingNewPayment = true
    this.changeRef.detectChanges()
    this.setupStripe('card-element');
  }

  returnToCheckout() {
    this.addingNewPayment = false
    this.changeRef.detectChanges()
  }

  async saveNewPayment() {

    this.addCard(() => {

      this.selectedCustomer = this.userService.user.customer
      this.returnToCheckout()
      this.changeRef.detectChanges()

    }, (errMsg: string) => {
      this.error(errMsg)
    })
  }

  async addCard(
    success: () => void,
    error: (errMsg: string) => void) {

    if (!this.cardFields.cardholderName) {
      this.error('Please enter cardholder name.')
      return
    }

    let loading = await this.loadingCtrl.create()
    loading.present()

    let data = {
      name: this.cardFields.cardholderName
    }

    this.stripe.createToken(this.card, data).then((result: any) => {

      if (result.error) {
        var errorElement = document.getElementById('card-errors');
        errorElement.textContent = result.error.message;
        loading.dismiss()
      } else {

        this.paymentService.createCustomer(

          result.token,
          this.cardFields.cardholderName,

          () => {
            loading.dismiss()
            success()
          }, (errorMsg: string) => {
            loading.dismiss()
            error(errorMsg)
        });
      }
    });
  }

  customerSelected(customer: any) {
    return this.selectedCustomer && this.selectedCustomer.id == customer.id
  }

  // -- end payment options --



  confirmPressed() {

    // this.analytics.track(AnalyticsService.ConfirmPressed)

    if (!this.selectedCustomer) {
      this.addCard(() => {
        this.payInvoice()
      }, (errMsg: string) => {
        this.error(errMsg)
      })
      return;
    }

    this.payInvoice()
  }

  payInvoice() {

    this.confirming = true
    this.changeRef.detectChanges()

    let params: PayInvoiceParams = {
      invoiceRequestID: this.invoiceRequestInfo.id,
      customerID: this.userService.user.customer.id
    }

    InvoiceTasks.payInvoice(params, () => {

      this.confirmed = true
      this.changeRef.detectChanges()

    }, (msg) => {

      this.alert.show('Error', msg);

    });
  }

  viewUpcoming() {
    this.navCtrl.navigateRoot('/appointments')
  }

  async viewReceipt() {

    let selectedServiceTypeList = new SelectedServiceTypeList()
    selectedServiceTypeList.items = this.invoiceRequestInfo.serviceTypeList
    selectedServiceTypeList.refreshText()

    const receiptModal = await this.modalCtrl.create({
      component: CostBreakdownPage,
      componentProps: {
        cost: this.invoiceRequestInfo.costs,
        selectedServiceTypeList: selectedServiceTypeList,
      },
      cssClass: 'auto-height'
    })

    await receiptModal.present();
  }






  // Helpers

  dateText(date: Date, timezoneOffset: number = 0) {
    let timezone = {
      offset: timezoneOffset,
    }
    return `${Util.dayMonthDate(date, timezone)}`
  }

  serviceTypeListText(serviceTypeList: any) {
    let list = new SelectedServiceTypeList()
    list.items = serviceTypeList
    list.refreshText()
    return list.longText
  }

  roundedRating(n: number) {
    return Math.round(n)
  }

  toRange(n: number) {
    return Util.toRange(n)
  }

  formatCost(num: number, currency: string) {
    return Util.formatCost(num, currency)
  }

  private error(msg: string) {
    this.alert.show('Error', msg)
  }
}
